module.exports = require('./helpers/bundle-url').getBundleURL('gA8FI') + "sollip-company.c4e68d8a.png";